import React from 'react'
import { ReactComponent as ZocksLogo } from '../../../assets/ZocksLogo.svg'
import { Button } from '../../../components/Button/Button'

interface CrossClientQueryErrorProps {
  onRestart: () => void
}

export const CrossClientQueryError = ({ onRestart }: CrossClientQueryErrorProps) => {
  return (
    <div className='d-flex flex-column'>
      <div className='d-flex zocks-gap-0.75 align-items-start'>
        <div className='d-flex align-items-center justify-content-center bg-black zocks-border-0.25 cross-client-loader-logo'>
          <ZocksLogo width={12} height={12} />
        </div>
        <div className='d-flex flex-column gap-3 align-items-start'>
          <div className='paragraph-medium'>I couldn't identify specific criteria from your question.</div>
          <div className='paragraph-medium'>Please add more details so I can search your clients effectively.</div>
        </div>
      </div>
      <div className='d-flex gap-2 align-items-center justify-content-end'>
        <Button variant='header' className='button-medium' onClick={onRestart}>
          Ask another question
        </Button>
      </div>
    </div>
  )
}
